//import Moment from "moment";

const getCount = (state) => {
	return state.requisicoesServico.length;
}

const getStatusAtualizacaoLista = (state) => {
	if (state.ultimaAtualizacaoLista == null) {
		return true;
	}
	else if(!state.requisicoesServico)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.requisicoesServico.length == 0 ||
			hour - state.ultimaAtualizacaoLista.getHours() > 0
		);
	}
}

export default {
	getCount,
	getStatusAtualizacaoLista
}